import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import appStore from 'stores/app';

import { Select, Col, Row, FormGroup, Label, Checkbox, Button, DefaultSheet, SheetBody, SheetFooter } from 'twyne-new.ui';

const propTypes = {
  isOpen: PropTypes.bool,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  groupOptions: PropTypes.array,
  params: PropTypes.object
};

class OptoutSummaryFilter extends React.Component {
  state = {
    params: {},
  }
  
  componentWillMount () {
    this.setState({params: _.cloneDeep(this.props.params)});
  }

  hasGroupKey = key => this.state.params.group.map(obj => obj.key).includes(key);

  handleChangeGroup = (obj) => {
    let params = this.state.params;
    const value = !this.hasGroupKey(obj.key);

    if (value && params.group.length >= 2) {
      return;
    }

    if (value) {
      params.group.push(obj);
    } else {
      const index = params.group.indexOf(obj);
      params.group.splice(index, 1);
    }

    this.setState({params});
  }

  handleChangeSite = (value) => {
    let params = this.state.params;
    params.filters.siteId = value;
    this.setState({params});
  }

  siteOptions = () => {
    const opts = appStore.sites.filter(site=>site.organizationId==appStore.site.organizationId).map(site => {
      return { value: site.id, label: site.name };
    });

    return opts;
  }

  render () {
    if (!this.props.isOpen) {
      return null;
    }

    return (
      <>
        <DefaultSheet
          title="Configure Filter"
          wrapperProps={{ open: this.props.isOpen, onOpenChange: this.props.onClose }}
        >
          <SheetBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Site</Label>
                  <Select
                    options={this.siteOptions()}
                    name="siteId"
                    placeholder="Select site"
                    value={this.state.params.filters.siteId}
                    onChange={opt => this.handleChangeSite(opt ? opt.value : null)}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Group By</Label>
                  <Row>
                    {this.props.groupOptions.map(obj => <Col size="6" key={obj.key} className='flex items-center gap-1'>
                      <Checkbox
                        name={obj.key}
                        value={this.hasGroupKey(obj.key)}
                        onChange={() => this.handleChangeGroup(obj)}
                      />
                      {obj.name}
                    </Col>)}
                  </Row>
                </FormGroup>
              </Col>
            </Row>
          </SheetBody>
          <SheetFooter>
            <Button onClick={this.props.onClose} variant="ghost">Cancel</Button>
            <Button onClick={() => this.props.onApply(this.state.params)} color="accent">Apply</Button>
          </SheetFooter>
        </DefaultSheet>
      </>
    );
  }
}

OptoutSummaryFilter.propTypes = propTypes;

export default OptoutSummaryFilter;
